import { h, Component } from 'preact';
import { timeFormat } from 'd3-time-format';
import PROJECTS from '../constants/projects';
import '../styles/Projects.css';

const IMAGE_DIR = 'assets/images/';
const TIME_FORMATTER = timeFormat('%B %Y');

// Process project list
PROJECTS.forEach(pj => {
  pj.dt = new Date(pj.dt);
});

// Sort projects (newest project first)
PROJECTS.sort((a, b) => {
  return b.dt - a.dt;
});


class Projects extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedDetail: null
    }
  }

  renderRoles(roles) {
    return roles.slice(1).map(role => {
      return <li>- {role}</li>;
    });
  }

  /*
    <div className='details'>
      <div className='table-wrapper'>
      <table>
        <tr className='details--title'>
          <td>Title:</td>
          <td>{project.title}</td>
        </tr>
        <tr className='details--date'>
          <td>Date:</td>
          <td>{TIME_FORMATTER(project.dt)}</td>
        </tr>
        <tr className='details--desc'>
          <td>Description:</td>
          <td>{project.desc}</td>
        </tr>
        <tr className='details--roles'>
          <td>Roles:</td>
          <td><ul>{this.renderRoles(project.roles)}</ul></td>
        </tr>
      </table>
      </div>
      <div className='details--link'><a href={project.link} target='_blank' rel='noopener noreferrer'>Visit Project</a></div>
    </div>

   */
   // <img className='image' src={img_src} alt={`${project.title} screenshot`}/>


  closeAllDetails() {

  }

  toggleDetails(evt, slug) {
    evt.preventDefault && evt.preventDefault();
    const {selectedDetail} = this.state;

    this.setState({
      selectedDetail: (slug === selectedDetail) ? null : slug
    });
  }

  renderProjects() {
    const {selectedDetail} = this.state;

    return PROJECTS.map(project => {
      const img_src = `${IMAGE_DIR}${project.images[0]}`;

      const img_style = {
        'background-image': `url(${img_src})`
      };

      let proj_class = 'Projects--project';
      if (project.slug === selectedDetail) {
        proj_class += ' show-details';
      }

      return (
        <div key={project.slug} id={project.slug} className={proj_class}>
          <div className='content'>
            <div className='image-wrapper'>
              <div className='img' style={img_style} />
              <div className='details-wrapper'>
                <ul className='details-list'>
                  <li>
                    <p>Date</p>
                    <p>{TIME_FORMATTER(project.dt)}</p>
                  </li>
                  <li>
                    <p>Description</p>
                    <p>{project.desc}</p>
                  </li>

                  <li>
                    <p>Additional roles</p>
                    <ul className='add-roles'>{this.renderRoles(project.roles)}</ul>
                  </li>
                </ul>
              </div>
            </div>
            <div className='proj-details'>
              <table>
                <tr>
                  <td>
                    <h3 className='proj-title'>{project.title}</h3>
                    <p className='proj-role'>{project.roles[0] || ''}</p>
                  </td>
                  <td className='proj-info'>
                    <a href={project.link} target='_blank' rel='noopener noreferrer'>Visit Project</a>
                    <button onclick={(evt) => this.toggleDetails(evt, project.slug)}><span className='plus'>+</span><span className='minus'>–</span> Details</button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      )
    });
  }

  render() {
    return (
      <section className="Projects">
        {this.renderProjects()}
      </section>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.js